import { Checkbox, Form, Button, notification } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { useForm } from "antd/es/form/Form";
import axiosClient from "../../api/axiosClient";
import handleApiError from "../../utils/handleError";
import { Loading } from "../../components";

export default function Notifications() {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = useForm();

  useEffect(() => {
    setLoading(true);
    axiosClient
      .get("notifications/maintenance")
      .then((res) => {
        form.setFieldsValue(res.data);
        setShow(res.data.enabled);
      })
      .catch((err) => handleApiError(err))
      .finally(() => setLoading(false));
  }, [form]);
  async function onFinish(values: any) {
    setLoading(true);
    try {
      await axiosClient.patch("notifications/maintenance", {
        id: "maintenance_notification",
        ...values,
      });
      notification.success({
        message: "Notifications of maintenance updated successfully.",
      });
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading ? <Loading /> : null}
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ maintenance: false }}
      >
        <Form.Item name="enabled" valuePropName="checked">
          <Checkbox onChange={({ target: { checked } }) => setShow(checked)}>
            Maintenance
          </Checkbox>
        </Form.Item>

        {show ? (
          <Form.Item
            name="message"
            label="Message"
            wrapperCol={{ xs: 24, sm: 24, md: 12 }}
          >
            <TextArea rows={8} />
          </Form.Item>
        ) : null}

        <Button htmlType="submit">Submit</Button>
      </Form>
    </>
  );
}
